<template>
	<div class="app-wrapper">

		<Login v-if="!logged"/>

		<transition name="fade">
			<Game v-if="logged"/>
		</transition>


		<Load />
		<Location v-if="user.id" />
		<ExitDialog v-if="logged" />

	</div>
</template>

<script>
	import Login from '../components/Views/Login.vue'
	import Location from '../components/Views/Location.vue'
	import Game from '../components/Views/Game.vue'
	import Load from '../components/Views/Load.vue'
	import ExitDialog from '../components/Views/ExitDialog'

	import style from '../assets/scss/app.scss';
	import bootstrap from 'bootstrap';


	export default {
		name: 'App',
		computed: {
			logged() { return this.$store.state.logged },
			location() { return this.$store.state.location },
			user() { return this.$store.state.user },
			start_date: {
				get() { return this.$store.state.start_date },
				set(value) { return this.$store.commit('setState', ['start_date', value])}
			}
		},
		methods: {

		},
		mounted() {
			this.start_date = this.moment().format();
		},
		components: {Game, Login, Load, ExitDialog, Location}

	}

</script>


